import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import _ from 'underscore'

import { StyledExtLink } from '../../Reusable/Link'
import { ErrorAlert } from '../../Reusable/Alert'
import { LabeledInput } from '../../Reusable/Input'
import { FlexColumn, Flex } from '../../Reusable/Container'
import { Text } from '../../Reusable/Text'
import { Button, TextButton } from '../../Reusable/Button'
import { apiGET, apiPOST } from '../../../Utils/api'
import { capitalizeWords } from '../../../Utils/util'
import AionLogo from '../../Reusable/Image'
import { message } from 'antd'


class Index extends Component {

    refArr = []

    state = {
        currentViewIndex: 0,
        submitLoading: false,
        stepProgress: 0,
        delivery: "text",
        codeInd: 0,
    }

    componentDidMount() {
        this.sendCode();

        _.times(6, (n) => {
            var r = React.createRef()
            this.refArr.push(r)
        });
    }

    handle2FAChange = (event) => {
        event.preventDefault()
        const nextInputId = parseInt(event.target.id) + 1
        var newState = Object.assign({ ...this.state }, { ["code_" + event.target.id]: event.target.value, codeInd: nextInputId })
        this.setState(newState)
        if (this.refArr[nextInputId] && (event.target.value != "")) this.refArr[nextInputId].current.focus()
        if (nextInputId == this.refArr.length) this.verifyCode(newState)
    }

    handle2FABackspace = (event) => {
        event.preventDefault()
        const prevInputId = parseInt(event.target.id) - 1
        var newState = Object.assign({ ...this.state }, { ["code_" + prevInputId]: event.target.value })
        this.setState(newState)
        if (this.refArr[prevInputId] && (event.target.value == "")) {
            this.refArr[prevInputId].current.focus()
            return
        }

    }

    handlePaste = (event) => {
        console.log("handlePaste", event.clipboardData.getData('Text'));
        const pastedTxt = event.clipboardData.getData('Text')
        // Reset code
        var updatedCode = {}
        _.times(6, (n) => {
            updatedCode["code_" + n] = pastedTxt[n] || ""
        })
        this.setState(updatedCode)
        if (updatedCode["code_5"]) this.verifyCode(Object.assign({ ...this.state }, updatedCode))
    }

    begin2FA = () => {
        this.sendCode()
    }

    sendCode = (options) => {
        options = options || {}
        var { delivery } = this.state
        var { resend } = options
        if (options.delivery) delivery = options.delivery
        if (delivery === "email") delivery = "mail"

        if (resend) {
            // Reset code
            var updatedCode = {}
            _.times(6, (n) => {
                updatedCode["code_" + n] = null
            })
            this.setState(updatedCode)
        }
        apiGET(`/mfa/generate?delivery=${delivery.toUpperCase()}`, null, (err, resp) => {
            try {
                if (err) throw Error(err)
                var data = resp.data
                console.log('twoFactorData', data)
                if (!data.success) throw Error("")
                if (resend) message.success("Successfully sent")
                this.setState({ loading: false, twoFactorData: data, step: 1, delivery: delivery })
            } catch (error) {
                console.log("2FA.SendCode", error, err, resp)
                ErrorAlert({ description: "Sorry we had trouble processing your request. Please try again." })
                this.setState({ loading: false })
            }
        })
    }

    verifyCode = (state) => {
        state = state || {}
        var code = ""
        _.times(6, (n) => {
            code = code + state["code_" + n]
        })
        if (this.state.loading) return // To avoid multiple clicks
        if (!code || _.isEmpty(code)) {
            // this.setError("code", "Please enter a valid code.");
            ErrorAlert({ description: "Please enter a valid code." })
            return;
        }
        var endpoint = "/mfa/verify"
        if (this.props.type) endpoint = `${endpoint}?type=${this.props.type}`
        let body = {
            "token": code
        }
        this.setState({ loading: true })
        console.log("verifyCode", endpoint, body)
        apiPOST(endpoint, null, body, (err, resp) => {
            try {
                if (err) throw Error(err)
                var data = resp.data
                if (!data.success) throw Error("")
                if (data.TokenValidated) {
                    this.props.twoFAValidated()
                } else {
                    this.setState({ loading: false })
                    ErrorAlert({ description: "Invalid verification code. Please enter the correct code or request a new one." })
                }
            } catch (error) {
                this.setState({ loading: false })
                ErrorAlert({ description: "Sorry we had trouble processing your request. Please try again." })
            }
        })
    }

    saveUserInput = (id, dataToSave) => {
        this.setState({ [id]: dataToSave })
    }

    validateFlow = () => {
        var { step, steps, code } = this.state

        if (steps[step] === "2FA.Verify" && !code) {
            return { validated: false, message: "Enter a valid code" }
        } else {
            return { validated: true }
        }
    }

    render() {
        var { delivery, twoFactorData, errorField, errorMessage, codeInd, loading } = this.state

        twoFactorData = twoFactorData || {}

        return (
            <FlexColumn center>
                <FlexColumn left gap='24px' style={{ padding: '24px', width: '550px' }}>
                    <AionLogo symbol margin='0px' />
                    <FlexColumn gap="24px">
                        <Text size="28px" weight="500" height="">Security Verification</Text>
                        <Text >To continue to stay logged in, we need you to complete your verification again.</Text>
                        <Text >{(twoFactorData || {}).Message || (twoFactorData || {}).msg}</Text>
                        <FlexColumn left gap="24px">
                            <Flex gap="8px">
                                {
                                    _.times(6, (n) => {
                                        return (
                                            <LabeledInput
                                                autoFocus={codeInd == n}
                                                inputRef={this.refArr[n]}
                                                id={n}
                                                key={n}
                                                type="code"
                                                // onFocus={e => e.target.select()}
                                                placeholder="_"
                                                onChange={this.handle2FAChange}
                                                onPaste={this.handlePaste}
                                                maxLength={1}
                                                error={errorField == `code_${n}`}
                                                errorMessage={errorMessage}
                                                value={this.state[`code_${n}`]}
                                                onKeyDown={(event) => { if (event.key == "Backspace" && event.target.value == "") this.handle2FABackspace(event) }}
                                                style={{ fontSize: "20px", weight: 400, lineHeight: "32px", textAlign: "center" }}
                                                width="60px"
                                                height="48px"
                                            />
                                        )
                                    })
                                }
                            </Flex>
                            <StyledExtLink key="StyledExtLink" style={{ textAlign: "center", fontSize: "16px", lineHeight: "24px", textDecoration: "underline" }} onClick={() => this.sendCode({ resend: true })}>Resend code</StyledExtLink>
                            <StyledExtLink
                                key="StyledExtLink" style={{ textAlign: "center", fontSize: "16px", lineHeight: "24px", textDecoration: "underline" }}
                                onClick={() => {
                                    this.sendCode({ resend: true, delivery: (delivery == "text") ? "email" : "text" })
                                }}
                            >
                                Send my code via {(delivery == "text") ? "email" : "text"}
                            </StyledExtLink>
                        </FlexColumn>
                    </FlexColumn>
                    <Button style={{ marginTop: 24 }} permtype="Override" solid loading={loading} onClick={() => this.verifyCode()} text={'Confirm'.toUpperCase()} />
                </FlexColumn>
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))